import Header from '../components/Header'
import Footer from '../components/Footer'

const About = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <div className="relative bg-gray-900">
          <div className="absolute inset-0">
            <img
              className="w-full h-full object-cover opacity-30"
              src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2850&q=80"
              alt="Digital marketing analytics"
            />
          </div>
          <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
						<div className="text-center">
              <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
                <span className="block">About TheMarketingFeeds.com</span>
              </h1>
              <p className="mt-4 max-w-2xl text-xl text-gray-100 mx-auto">
                Driving digital transformation for businesses worldwide.
              </p>
            </div>
					</div>
        </div>

        <div className="bg-gray-50">
          <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
            <div className="lg:grid lg:grid-cols-2 lg:gap-8">
              <div>
                <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
                  Our Story
                </h2>
                <div className="mt-6 text-lg text-gray-500 space-y-6">
                  <p>
                    Founded in 2015, TheMarketingFeeds.com began as a small team of digital marketing enthusiasts with a passion for helping businesses grow online. What started as a boutique agency focused on social media campaigns has evolved into a full-service digital marketing powerhouse.
                  </p>
                  <p>
                    Today, we serve clients across 15 countries, helping them navigate the complex digital landscape with innovative solutions and data-driven strategies.
                  </p>
                  <p>
                    Our mission is to deliver exceptional results through creativity, technology, and relentless optimization.
                  </p>
                </div>
              </div>
              <div className="mt-12 lg:mt-0">
                <img
                  className="w-full rounded-lg shadow-lg"
                  src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80"
                  alt="Our team working together"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="bg-white">
          <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl text-center mb-12">
              Our Core Values
            </h2>
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
              <div className="pt-6">
                <div className="flow-root bg-gray-50 rounded-lg px-6 pb-8 h-full">
                  <div className="-mt-6">
                    <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                      <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                      </svg>
                    </div>
                    <h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight">Results-Driven</h3>
                    <p className="mt-5 text-base text-gray-500">
                      We measure success by the tangible results we deliver for our clients, not just the work we do.
                    </p>
                  </div>
                </div>
              </div>
              <div className="pt-6">
                <div className="flow-root bg-gray-50 rounded-lg px-6 pb-8 h-full">
                  <div className="-mt-6">
                    <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                      <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                      </svg>
                    </div>
                    <h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight">Transparency</h3>
                    <p className="mt-5 text-base text-gray-500">
                      We believe in open communication and clear reporting, so you always know where your investment is going.
                    </p>
                  </div>
                </div>
              </div>
              <div className="pt-6">
                <div className="flow-root bg-gray-50 rounded-lg px-6 pb-8 h-full">
                  <div className="-mt-6">
                    <div className="flex items-center justify-center h-12 w-12 rounded-md bg-primary text-white">
                      <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </div>
                    <h3 className="mt-8 text-lg font-medium text-gray-900 tracking-tight">Innovation</h3>
                    <p className="mt-5 text-base text-gray-500">
                      We stay ahead of the curve, constantly testing new strategies and technologies to keep our clients competitive.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gray-50">
          <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl text-center mb-12">
              Meet Our Leadership Team
            </h2>
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
              <div className="bg-white rounded-lg shadow overflow-hidden">
                <img className="w-full h-48 object-cover" src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60" alt="Team member" />
                <div className="p-6">
                  <h3 className="text-lg font-medium text-gray-900">Charly Albin</h3>
                  <p className="text-primary mt-1">CEO & Founder</p>
                  <p className="mt-3 text-base text-gray-500">
                    With over 15 years in digital marketing, Charly founded TheMarketingFeeds.com to bridge the gap between technology and creative marketing.
                  </p>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow overflow-hidden">
                <img className="w-full h-48 object-cover" src="https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60" alt="Team member" />
                <div className="p-6">
                  <h3 className="text-lg font-medium text-gray-900">Carl Albin</h3>
                  <p className="text-primary mt-1">CTO</p>
                  <p className="mt-3 text-base text-gray-500">
                    Albin leads our technology initiatives, ensuring our SaaS solutions and marketing tools are cutting-edge and scalable.
                  </p>
                </div>
              </div>
              <div className="bg-white rounded-lg shadow overflow-hidden">
                <img className="w-full h-48 object-cover" src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=500&q=60" alt="Team member" />
                <div className="p-6">
                  <h3 className="text-lg font-medium text-gray-900">Sol Arin</h3>
                  <p className="text-primary mt-1">Director of Marketing</p>
                  <p className="mt-3 text-base text-gray-500">
                    Arin oversees all client campaigns, bringing a data-driven approach to creative marketing strategies.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default About